module.exports = __webpack_public_path__ + "media/images/brand_icons/icon_stride-29e0dac8d19bec0e309c5e875de5c808.svg";